<!-- about-promo.html -->
<div class="aboutComponent flex items-center justify-center">
    <div class="w-full max-w-4xl">
        <!-- Card/border container -->
        <div class="relative rounded-2xl border border-pink-200 bg-white px-6 sm:px-10 py-10 sm:py-12 text-center">

            <!-- Top brand row (logo + heartmark stacked like in mock) -->
            <div class="flex flex-col items-center gap-2">
                <!-- Main wordmark + heart icon (single row) -->
                <div class="flex items-center justify-center gap-3">
                    <img src="../../../assets/images/Cardio4Cities_Accelerator_logo.svg" alt="CARDIO4Cities"
                        class="h-[80px] object-contain" />
                </div>
            </div>

            <!-- Description -->
            <p class="mt-8 text-slate-700 text-sm sm:text-base md:text-lg leading-relaxed">
                The Cardio4Cities Simulator forecasts the future burden of cardiovascular disease and helps cities
                design effective strategies to reduce it.
            </p>

            <!-- Link -->
            <div class="mt-6 mb-6">
                <a href="https://www.cardio4citiesaccelerator.org" target="_blank" rel="noopener"
                    class="inline-flex items-center gap-2 text-sky-700 hover:text-sky-800 font-semibold underline decoration-2 underline-offset-4">
                    www.cardio4citiesaccelerator.org
                </a>
            </div>


            <!-- Optional bottom decorative baseline (faint heartbeat line across card) -->
        </div>
    </div>
</div>